// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__7ge9x","modal_wrapper":"modal_modal_wrapper__L+Cen","close_modal":"modal_close_modal__OpOi0","openModal":"modal_openModal__37or4"};